import React from 'react';
import '../styles/index.css'
import { useTranslation } from 'react-i18next'; 

const AlertDialog = ({ message, onClose }) => {

  const { t } = useTranslation();

  if (!message) return null; // No renderizar si no hay mensaje

  return (
    <div className="alert-dialog-overlay">
      <div className="alert-dialog-content">
        <h3 className="alert-dialog-title">{t('alertTitle')}</h3>
        <p className="alert-dialog-message">{message}</p>
        <button onClick={onClose} className="alert-dialog-button">
          {t('alertButton')}
        </button>
      </div>
    </div>
  );
};

export default AlertDialog;